require('./lib/modernizr');
require('./lib/polyfills');

var Timeline = require('timeline');
var videoSequence = require('./lib/video-promise');
var getURLParameter = require('./lib/getURLParameters');
var getConfig = require('./lib/getConfig');
var getFileExtension = require('./lib/getFileExtension');
var $ = require('jquery');

var timeline = new Timeline();

var init = function (config) {

  var template = require('./templates/mainVideo.hbs');
  var videoAssets = config.assets.mainvideo.map(function (videoURL) {
    return {
      src: videoURL,
      type: 'video/' + getFileExtension(videoURL)
    };
  });
  var compiled = template(videoAssets);
  var $main = $('#main');
  $main.prepend(compiled);

  // Video Callbacks
  var video1 = videoSequence(mainVideo, 0, "0:00:20:07");
  var video2 = videoSequence(mainVideo, "0:00:25:07", "0:00:30:17");
  var video3 = videoSequence(mainVideo, "0:00:35:17", "0:00:59:11");
  var video4 = videoSequence(mainVideo, "0:01:04:11", "0:01:50:14");
  var video5 = videoSequence(mainVideo, "0:01:55:14", "0:02:30:02");
  var video6 = videoSequence(mainVideo, "0:02:35:02", "0:03:11:13");
  var video7 = videoSequence(mainVideo, "0:03:16:13 ");

  var intro = require('./views/intro');
  var challenge1 = require('./views/challenge1');
  var challenge2 = require('./views/challenge2');
  var challenge3 = require('./views/challenge3');
  var challenge4 = require('./views/challenge4');
  var challenge5 = require('./views/challenge5');
  var challenge6 = require('./views/challenge6');
  var outro = require('./views/outro');

  var restart = function () {
    mainVideo.currentTime = 0;
    return Promise.resolve()
      .then(function () {
        timeline.play();
        return "You finished!!!";
      });
  };

  timeline.addSequences([
    intro,
    video1.start,
    challenge1,
    video2.start,
    challenge2,
    video3.start,
    challenge3,
    video4.start,
    challenge4,
    video5.start,
    challenge5,
    video6.start,
    challenge6,
    video7.start,
    outro,
    restart
  ]);

  var startIndex = getURLParameter("startindex") || 0;


  timeline.play(startIndex);

};

getConfig().then(init);
